import { render, staticRenderFns } from "./InStore.vue?vue&type=template&id=20f7816a&scoped=true&"
import script from "./InStore.vue?vue&type=script&lang=js&"
export * from "./InStore.vue?vue&type=script&lang=js&"
import style0 from "./InStore.vue?vue&type=style&index=0&id=20f7816a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7816a",
  null
  
)

export default component.exports